import { TNavigationItem } from 'components_new/molecules/NavigationItem'

export const getNavigationsItems = (): TNavigationItem[] => {
  const items: TNavigationItem[] = [
    {
      activePattern: '/data-platform/ontology*',
      icon: { name: 'LanTwoTone' },
      href: '/data-platform/ontology/standard',
      title: 'Informationsmodell'
    },
    {
      activePattern: '/data-platform/collect*',
      icon: { name: 'StorageTwoTone' },
      href: '/data-platform/collect/sources',
      title: 'Ansluten data'
    },
    {
      activePattern: '/security/credentials',
      icon: { name: 'Lock' },
      href: '/security/credentials',
      title: 'Hemliga uppgifter'
    },
    {
      activePattern: '/internal/data-health*',
      icon: { name: 'MonitorHeartOutlined' },
      href: '/internal/data-health/overview',
      title: 'Datahälsa'
    },
    {
      activePattern: '/internal/sim-chats*',
      icon: { name: 'AI' },
      href: '/internal/sim-chats',
      title: 'SIM-chattar'
    },
    {
      activePattern: '/lists*',
      divider: true,
      icon: { name: 'ViewListTwoTone' },
      href: '/lists',
      title: 'Listor'
    },
    {
      activePattern: '/internal/metric-studio*',
      icon: { name: 'Calculation' },
      href: '/internal/metric-studio',
      title: 'Mätetalsstudion'
    },
    {
      activePattern: '/internal/users*',
      divider: true,
      icon: { name: 'Diversity1TwoTone' },
      href: '/internal/users',
      title: 'Våra användare'
    },
    {
      activePattern: '/internal/customers*',
      icon: { name: 'AI' },
      href: '/internal/customers',
      title: 'Våra kunder'
    },
    {
      activePattern: '/internal/status-banner*',
      divider: true,
      icon: { name: 'CampaignTwoTone' },
      href: '/internal/status-banner',
      title: 'Banner'
    },
    {
      activePattern: '/internal/trust-links*',
      icon: { name: 'Lock' },
      href: '/internal/trust-links',
      title: 'Läslänkar'
    }
  ]

  return items
}
